import { FieldErrors, UseFormWatch } from "react-hook-form";
import { LabledInputClasses } from "./LabeledInput";
import { useState } from "react"

interface Props {
  label: string;
  textareaName: string;
  watch: UseFormWatch<any>;
  classes?: Partial<LabledInputClasses>;
  errors: FieldErrors;
}

export default function LabeledTextarea({
  label,
  textareaName,
  watch,
  classes,
  errors,
  ...textareaProps
}: Props) {
  const hasError = !!errors[textareaName];

  const [isFocused, setIsFocused] = useState(false);

  const value = watch(textareaName);
  const isActive = isFocused || !!value

  return (
    <div className={`labeled-textarea__wrapper ${isActive ? 'active' : ''} ${classes ? classes.wrapper : ''}`}>
      <textarea
        className={`labeled-textarea__textarea ${hasError ? "invalid" : ""} ${classes ? classes.field : ''}`}
        {...textareaProps}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <label className={`labeled-textarea__label ${classes ? classes.label : ''}`}>
        {label}
      </label>
    </div>
  );
}
